import Documentacion from '../components/Documentacion';
import PuertosAutoridades from '../components/PuertosAutoridades';
import Recomendaciones from '../components/Recomendaciones';
import PreguntasFrecuentesAntes from '../components/preguntasFrecuentes/PreguntasFrecuentesAntes';


export default function Antes({ route }) {

    
  if (!route) return <p>Selecciona una ruta</p>;

  return (
    <>
                    
      <Documentacion />
      <Recomendaciones />
      <PuertosAutoridades />        
      <PreguntasFrecuentesAntes />
    

    </>
  )
}
